export default __webpack_public_path__ + "static/media/linkedin.d90e0024.svg";